// extracted by mini-css-extract-plugin
export default {"link":"link--Aol0M","iconEye":"iconEye--ZIlpu","iconPlay":"iconPlay--k9xmF","seeMore":"seeMore--Nl6GP","watch":"watch--y7VWR","l":"l--qXw_f","m":"m--G3CY3"};